import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn, easeOutCubic } from '../../utils';

export const DialogOverlay = ({
  isOpen,
  handleClose,
  children,
}: {
  isOpen: boolean;
  handleClose: () => void;
  children: React.ReactElement;
}) => {
  const animationVariants = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: isOpen ? 1 : 0,
      transition: {
        duration: 0.2,
        ease: easeOutCubic,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.1,
        ease: easeOutCubic,
      },
    },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          variants={animationVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          className={cn(
            'p-0 items-end sm:p-6 top-0 w-full left-0 h-full fixed sm:items-center justify-center z-50',
            {
              flex: isOpen,
              hidden: !isOpen,
            },
          )}
          style={{ backgroundColor: 'rgba(0,0,0, .5)' }}
          onClick={handleClose}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
